export enum ResultActionTypes {
  UPDATE_RESULT_FILTER = 'UPDATE_RESULT_FILTER',
  UPDATE_RESULT_BASIC_COLOR = 'UPDATE_RESULT_BASIC_COLOR',
}
